import type {FabricObject} from '~/common/fabric/types';

export const deriveIdFromCanvasObject = (canvasObject: FabricObject) =>
  `${canvasObject.left}${canvasObject.top}${canvasObject.height}${canvasObject.width}`;
